import * as React from 'react';
import {useEffect, useState, useCallback, useMemo} from 'react';
import useJumpUrl from '@/hooks/useJumpUrl';
import {TopicModule} from '@/services/pages/channel/channel.client';
import Title from '@/components/common/title';
import {VALUE_TYPE} from '@/dicts/consts';
import styles from './index.less';

interface propsType {
    page: string;
    sfRef?: string;
    infos: TopicModule;
    channelBusinessLine?: string;
    ubcValue: string;
}

interface fieldValueType {
    img?: string;
    link?: string;
    swanUrl?: string;
    itemId?: number;
    title?: string;
}

const SeamlessPuzzle = ({page, channelBusinessLine, infos, ubcValue}: propsType) => {

    const [imgArray, setImgArray] = useState<fieldValueType[][]>([]);

    const [column, setColumn] = useState<number>(3);

    const {navigateToUrl} = useJumpUrl();

    const handleClick = useCallback(
        (linkUrl?: string, swanUrl?: string, item?) => {
            const urlParams = {
                linkUrl,
                swanUrl,
            };
            const logParams = {
                page: page,
                value: ubcValue,
                channelId: infos?.channelId,
                pageType: channelBusinessLine,
                moduleId: infos?.moduleId,
                moduleName: infos?.moduleName,
                customize: {
                    // eslint-disable-next-line camelcase
                    value_type: VALUE_TYPE.ITEM,
                    // eslint-disable-next-line camelcase
                    value_id: item.itemId,
                    // eslint-disable-next-line camelcase
                    value_title: item.title,
                },
            };
            navigateToUrl(urlParams, logParams);
        },
        [
            navigateToUrl,
            page,
            ubcValue,
            infos.channelId,
            channelBusinessLine,
            infos.moduleId,
            infos.moduleName,
        ]
    );

    const getCusWidth = useMemo(
        () => {
            return {
                width: `calc(100% / ${column})`,
            };
        },
        [column]
    );

    useEffect(
        () => {
            if (infos?.moduleMaxColumns) {
                setColumn(infos.moduleMaxColumns);
            }
            const imagesArray: fieldValueType[] = [];
            infos?.itemList && infos?.itemList?.length > 0 && infos.itemList.forEach(list => {
                const imageObj: fieldValueType = Object.assign(
                    {
                        itemId: list.itemId,
                        title: list.title,
                    },
                    list.fieldValue
                );
                list.fieldValue && imagesArray.push(imageObj);
            });
            // 根据列数将一维数组分割成二维数组
            const group = (array: fieldValueType[], subGroupLen: number) => {
                if (array && array.length) {
                    let index = 0;
                    const newArray = [];
                    while (index < array.length) {
                        newArray.push(array.slice(index, index += subGroupLen));
                    }
                    return newArray;
                }
            };
            setImgArray(group(imagesArray, column)!);
        },
        [infos?.itemList, infos?.moduleMaxColumns, column]
    );

    const renderDom = useCallback(
        () => {
            return (
                <div>
                    {
                        imgArray?.length > 0 && imgArray.map(
                            (list, index) => (
                                <div key={JSON.stringify(index)} className={styles.imageContent}>
                                    {
                                        list?.map(
                                            item => (
                                                <img
                                                    key={item?.itemId}
                                                    src={item?.img}
                                                    style={getCusWidth}
                                                    onClick={() => {
                                                        handleClick(item?.link, item?.swanUrl, item);
                                                    }}
                                                    data-show={JSON.stringify({
                                                        'page': page,
                                                        'value': ubcValue,
                                                        'pageSourceId': infos.channelId,
                                                        'pageType': channelBusinessLine,
                                                        'valueId': item.itemId,
                                                        'valueTitle': item.title,
                                                        'valueType': VALUE_TYPE.ITEM,
                                                    })}
                                                />
                                            )
                                        )
                                    }
                                </div>
                            )
                        )
                    }
                </div>
            );
        },
        [channelBusinessLine, getCusWidth, handleClick, imgArray, infos.channelId, page, ubcValue]
    );

    return (
        <div
            data-show={JSON.stringify({
                'page': page,
                'value': ubcValue,
                'pageSourceId': infos?.channelId,
                'pageType': channelBusinessLine,
                'valueId': infos?.moduleId,
                'valueTitle': infos?.moduleName,
                'valueType': VALUE_TYPE.MODULE,
            })}
        >
            {
                (infos?.isShowTitle === 1 && (infos?.moduleName || infos?.moduleSubTitle))
                && (
                    <div className={styles.titleWrap}>
                        <Title
                            title={infos?.moduleName ?? ''}
                            subTitle={infos?.moduleSubTitle ?? ''}
                            moreLink={infos?.moreUrl ?? ''}
                        />
                    </div>
                )
            }
            {
                imgArray?.length > 0 && (
                    <div className={styles.container}>
                        {
                            renderDom()
                        }
                    </div>
                )
            }
        </div>
    );
};

export default SeamlessPuzzle;
